var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "participateList",
    class: {
      fullScreen: _vm.fullScreen,
      notShowFootBar: !_vm.State.showFootBar,
      onlyMainWindow: _vm.onlyMainWindow,
      uploadLogo: _vm.uploadLogo,
      participateFullScreen: _vm.fullScreen && _vm.$route.name == 'kioskParticipate',
      isVertical: _vm.State.isVertical
    }
  }, [_c('div', {
    staticClass: "content clearfix",
    class: {
      showChatMessage: _vm.showChatMessage
    }
  }, [_c('div', {
    staticClass: "listBox",
    class: {
      isVertical: _vm.State.isVertical
    }
  }, [_c('div', {
    style: _vm.layoutStyle,
    attrs: {
      "id": "containerCanvas"
    }
  }, _vm._l(_vm.rtilList, function (val, index) {
    var _vm$streamInfo$val;
    return _c('div', {
      key: val,
      class: `item item-${index + 1} ${val + ';' + _vm.userInfo.rtilCode} ${_vm.isallScrren && _vm.streamInfo[val] && val == _vm.streamInfo[val].shareCode ? 'shareFullScreen' : ''}`,
      style: _vm.isMainwindowReturnStyle(val, index)
    }, [val == _vm.userInfo.rtilCode ? _vm._t("localStream") : _vm.isMainWindow[val] ? _c('NewAttendUser', {
      key: val,
      ref: `mainWindow${val}`,
      refInFor: true,
      staticClass: "streamBox mainwindowBox",
      class: {
        'bitrate8-9': _vm.outputSourceType == 'Pbp',
        notShowFootBar: !_vm.State.showFootBar,
        fullScreen: _vm.isFullScreen
      },
      attrs: {
        "devicePlatform": _vm.devicePlatform[val],
        "deviceType": _vm.deviceType[val],
        "degreeHost": _vm.degreeHost[val],
        "userInfo": _vm.userInfo,
        "singChannel": _vm.streamInfo[val] || {},
        "title": _vm.returnTitle(val),
        "nickName": _vm.behaviorInfo[val],
        "showMuteIcons": _vm.outputSourceType == 'Pbp' && _vm.showMuteIcons ? true : false,
        "notShowPraviteBg": true,
        "showOperateBox": _vm.outputSourceType == 'Pbp' ? true : false,
        "isAudioLevel": _vm.isAudioLevel,
        "outputRtilCode": val,
        "outputSourceType": _vm.outputSourceType,
        "muteVideo": !_vm.State.cameraStatus[val],
        "muteAudio": !_vm.State.micStatus[val],
        "rtc": _vm.rtc[_vm.streamInfo[val] ? _vm.streamInfo[val].channel : ''],
        "liveInfo": _vm.rtilStatusObj[val]
      },
      on: {
        "changeFullScreen": _vm.changeFullScreen,
        "callback": _vm.operateCallback
      },
      scopedSlots: _vm._u([_vm.host && _vm.outputSourceType == 'Pbp' ? {
        key: "videoBottom",
        fn: function () {
          return [_c('div', {
            staticClass: "rList"
          }, [_c('LiveSourceSelect', {
            attrs: {
              "allRList": _vm.receiverList,
              "partyCode": _vm.streamInfo[val].channel,
              "nickName": _vm.behaviorInfo[val],
              "rtilCode": val,
              "useNewUi": true,
              "memberId": _vm.streamInfo[val].tid,
              "liveInfo": _vm.rtilStatusObj[val] || {}
            },
            on: {
              "callback": _vm.callbackByLiveSource
            }
          })], 1)];
        },
        proxy: true
      } : null], null, true)
    }, [!_vm.streamInfo[val] ? _c('div', {
      staticClass: "defaultBox"
    }, [_c('div', {
      staticClass: "pgmBox"
    }, [_c('div', [_c('img', {
      attrs: {
        "src": _vm.logoGray
      }
    }), _vm.outputSourceType == 'Pbp' ? _c('div', {
      staticClass: "text"
    }, [_vm._v(" " + _vm._s(_vm.pbpNoSourceText[val]) + " ")]) : _vm._e(), _vm.outputSourceType != 'Pbp' ? _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm.$t('mainWindow.noSource')))]) : _vm._e(), _vm.outputSourceType != 'Pbp' ? _c('div', [_vm._v(_vm._s(_vm.$t('mainWindow.sourceFromWindow')))]) : _vm._e()])])]) : _vm._e(), _vm.host && _vm.outputSourceType != 'Pbp' && _vm.streamInfo[val] && (_vm.outputSourceType == 'shareScreen' || _vm.outputSourceType == 'Pbp') ? _c('div', {
      staticClass: "rList liveWidthMinWindow"
    }, [_c('LiveSourceSelect', {
      attrs: {
        "allRList": _vm.receiverList,
        "partyCode": _vm.streamInfo[val].channel,
        "nickName": _vm.behaviorInfo[val],
        "rtilCode": val,
        "useNewUi": true,
        "memberId": _vm.streamInfo[val].tid,
        "liveInfo": _vm.rtilStatusObj[val] || {}
      },
      on: {
        "callback": _vm.callbackByLiveSource
      }
    })], 1) : _vm._e()]) : _c('NewAttendUser', {
      ref: `remoteSource${val}`,
      refInFor: true,
      staticClass: "streamBox",
      attrs: {
        "devicePlatform": _vm.devicePlatform[val],
        "anywherePopShow": _vm.anywherePopShow[val],
        "deviceType": _vm.deviceType[val],
        "degreeHost": _vm.degreeHost[val],
        "rtc": _vm.rtc[_vm.streamInfo[val] ? _vm.streamInfo[val].channel : ''],
        "singChannel": _vm.streamInfo[val] || {},
        "title": "Pip",
        "nickName": _vm.behaviorInfo[val],
        "userInfo": _vm.userInfo,
        "isAudioLevel": _vm.isAudioLevel,
        "muteVideo": !_vm.State.cameraStatus[val],
        "muteAudio": !_vm.State.micStatus[val],
        "showOperateBox": _vm.isallScrren && _vm.streamInfo[val] && val == _vm.streamInfo[val].shareCode ? false : true,
        "operateList": _vm.operateList[val],
        "volume": _vm.streamInfo[val] ? _vm.voiceList[val] : {
          level: 0
        },
        "tagName": _vm.host ? _vm.tagNameInfo[val] : '',
        "showMuteIcons": _vm.streamInfo[val] && _vm.showMuteIcons ? true : false,
        "liveInfo": _vm.rtilStatusObj[val],
        "remoteNetWorks": _vm.remoteNetWorks[val],
        "showPipCursorPointer": _vm.showPipCursorPointer
      },
      on: {
        "callback": _vm.operateCallback,
        "updateList": _vm.updateTag
      },
      scopedSlots: _vm._u([_vm.host ? {
        key: "videoBottom",
        fn: function () {
          return [_c('div', {
            staticClass: "rList"
          }, [_c('LiveSourceSelect', {
            attrs: {
              "allRList": _vm.receiverList,
              "partyCode": _vm.streamInfo[val].channel,
              "nickName": _vm.behaviorInfo[val],
              "rtilCode": val,
              "useNewUi": true,
              "memberId": _vm.streamInfo[val].tid,
              "liveInfo": _vm.rtilStatusObj[val] || {}
            },
            on: {
              "callback": _vm.callbackByLiveSource
            }
          })], 1)];
        },
        proxy: true
      } : null], null, true)
    }, [_c('span', {
      staticClass: "test hide"
    }, [_vm._v(" streamInfo - " + _vm._s(_vm.streamInfo[val] ? '有stream对象' : '') + ", channel - " + _vm._s(_vm.streamInfo[val] ? _vm.streamInfo[val].channel : '') + ", videoTrack - " + _vm._s(_vm.streamInfo[val] && _vm.streamInfo[val].videoTrack ? '有videoTrack' : '') + ", behaviorInfo- " + _vm._s(_vm.behaviorInfo[val]) + " ")]), _vm.showMoveIcon && !((_vm$streamInfo$val = _vm.streamInfo[val]) !== null && _vm$streamInfo$val !== void 0 && _vm$streamInfo$val.shareCode) ? _c('div', {
      staticClass: "checkBox"
    }, [_c('el-checkbox', {
      on: {
        "change": function ($event) {
          return _vm.moveParty($event, val);
        }
      },
      model: {
        value: _vm.movePips[val],
        callback: function ($$v) {
          _vm.$set(_vm.movePips, val, $$v);
        },
        expression: "movePips[val]"
      }
    })], 1) : _vm._e()])], 2);
  }), 0)]), _vm._t("rightBox")], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };